import { useCallback } from 'react';
import { ILegalMeta, useLegalList } from '~/utils/legal-list';

import './style.scss';

const COPYRIGHT: string = '©2025 Heliophilia Pte. Ltd. All Rights Reserved.';

export const Footer = () => {
  const legalList = useLegalList();

  const handleLegalClick = useCallback(
    (position: string) => () => {
      window.Tea('wap_click', {
        current_position: position,
        is_cta: 0,
      });
    },
    [],
  );

  return (
    <div className={'main_footer'}>
      <ul className="legal_list">
        {legalList.map((l: ILegalMeta) => (
          <li key={l.displayName}>
            <a href={l.href} target="_blank" onClick={handleLegalClick(l.clickPosition)}>
              {l.displayName}
            </a>
          </li>
        ))}
      </ul>
      <p>{COPYRIGHT}</p>
    </div>
  );
};
